import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Star, Quote } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TestimonialsPage = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const response = await axios.get(`${API}/testimonials`);
      setTestimonials(response.data);
    } catch (error) {
      console.error('Error fetching testimonials:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950">
      <Navbar />

      <div className="container mx-auto px-4 md:px-6 max-w-7xl py-16">
        <div className="mb-16">
          <h1 className="text-6xl md:text-8xl font-bold tracking-tighter uppercase leading-[0.9] mb-4 font-heading">
            <span className="text-lime-400">Customer</span> Stories
          </h1>
          <p className="text-base md:text-lg leading-relaxed text-zinc-300 max-w-3xl">
            Hear from Bengaluru businesses and homes who made the switch from LPG to briquettes.
          </p>
        </div>

        {loading ? (
          <div className="text-center py-20">
            <div className="inline-block w-12 h-12 border-4 border-lime-400 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-zinc-900 border border-zinc-800 p-8 hover:border-lime-400/50 transition-colors relative"
                data-testid={`testimonial-card-${testimonial.id}`}
              >
                <Quote className="w-12 h-12 text-lime-400/20 absolute top-4 right-4" />
                
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-lime-400 text-lime-400" />
                  ))}
                </div>

                <p className="text-zinc-300 leading-relaxed mb-6 relative z-10">
                  "{testimonial.content}"
                </p>

                <div className="border-t border-zinc-800 pt-4">
                  <p className="font-semibold text-white text-lg font-heading uppercase">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-zinc-400 mb-1">{testimonial.business_type}</p>
                  <p className="text-xs text-lime-400">{testimonial.location}</p>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="mt-16 bg-zinc-900 border border-zinc-800 p-8 text-center">
          <h2 className="font-heading text-3xl font-bold uppercase mb-4">
            Join Our <span className="text-lime-400">Happy Customers</span>
          </h2>
          <p className="text-zinc-300 mb-6 max-w-2xl mx-auto">
            Make the switch from LPG to briquettes today. Experience the cost savings, reliability, 
            and eco-friendly benefits that our customers rave about.
          </p>
          <a
            href="https://wa.me/919876543210"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-lime-400 text-black hover:bg-lime-500 font-bold uppercase tracking-wider px-8 py-4 shadow-[4px_4px_0px_0px_#ffffff] transition-all hover:-translate-y-1"
            data-testid="whatsapp-cta"
          >
            WhatsApp Us: +91-9876543210
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TestimonialsPage;
